import { getTeamPageUrl } from "../../../../utils/urls"
import Link from "next/link"
import { LocalizedSeasonTeamPlayer } from "../../../../types/seasonTeamPlayer"
import * as ImageConstants from "../../../../constants/images"
import Image from "next/image"
import { LocalizedTeam } from "../../../../types/team"
import { orderBy } from "lodash"
import { Row, Col } from "react-bootstrap"
import style from "./style.module.scss"

type TeamWithSeasonName = LocalizedTeam & {
  seasonName: string
  lastYear: number
}

export function teamsToAggregatedTeams(teams: LocalizedSeasonTeamPlayer[]) {
  const filteredTeams: TeamWithSeasonName[] = []

  const teamSet: LocalizedTeam[] = []

  teams.reverse().forEach((seasonTeamPlayer) => {
    if (!teamSet.find((t) => t.id === seasonTeamPlayer.teamId) && seasonTeamPlayer.team) {
      teamSet.push(seasonTeamPlayer.team)
    }
  })

  teamSet.forEach((team) => {
    const seasons = teams.filter((t) => t.teamId === team.id).map((t) => t.season)

    if (seasons.length > 0) {
      let firstSeason = seasons[0]
      let lastSeason = seasons[seasons.length - 1]

      for (let i = 0; i < seasons.length - 1; i++) {
        const currentSeason = seasons[i]
        const futureSeasons = seasons[i + 1]
        if (currentSeason && futureSeasons && currentSeason.year + 1 !== futureSeasons.year) {
          lastSeason = currentSeason

          const newTeam = { ...JSON.parse(JSON.stringify(team)), seasonName: "" }

          if (firstSeason?.name !== lastSeason?.name) {
            newTeam["seasonName"] = `${firstSeason?.name} - ${lastSeason ? lastSeason.name : "-"}`
          } else {
            newTeam["seasonName"] = firstSeason?.name
          }

          newTeam["lastYear"] = lastSeason ? lastSeason.year : 0

          filteredTeams.push(newTeam)

          firstSeason = futureSeasons
        }
      }

      lastSeason = seasons[seasons.length - 1]

      const newTeam = { ...JSON.parse(JSON.stringify(team)), seasonName: "", lastYear: 0 }

      if (firstSeason?.name !== lastSeason?.name) {
        newTeam["seasonName"] = `${firstSeason?.name} - ${lastSeason ? lastSeason.name : "-"}`
      } else {
        newTeam["seasonName"] = firstSeason?.name
      }

      newTeam["lastYear"] = lastSeason ? lastSeason.year : 0

      filteredTeams.push(newTeam)
    }
  })

  return orderBy(filteredTeams, ["seasonName"], ["desc"])
}

export function PlayerCareer({ teams }: { teams: LocalizedSeasonTeamPlayer[] }) {
  const clubs = teams.filter((t) => t.team?.type === "club")
  const nationals = teams.filter((t) => t.team?.type === "national")

  const aggregatedClubs = teamsToAggregatedTeams(clubs)

  const aggregatedNationals = teamsToAggregatedTeams(nationals)

  return (
    <div className={style.playerCareerMainContainer}>
      <Row>
        <Col className={style.playerCareerContainer} md={6} lg={6} xl={6}>
          <h3>Squadre</h3>
          <table>
            <thead>
              <tr>
                <th>Stagione</th>
                <th>Squadra</th>
              </tr>
            </thead>
            <tbody>
              {aggregatedClubs.length > 0 &&
                aggregatedClubs.map((teamWithSeasonName, index) => {
                  const team = teamWithSeasonName
                  const teamUrl = getTeamPageUrl(team.calciocomSlug!)

                  return (
                    <tr key={index} data-gender="male">
                      <td>{teamWithSeasonName.seasonName}</td>
                      <td>
                        <div className={style.content}>
                          <Link href={teamUrl}>
                            <a title={team.name}>
                              <Image
                                src={team.image?.path || ImageConstants.TEAM_MISSING_IMAGE_PATH}
                                alt={team.name}
                                title={team.name}
                                layout={"intrinsic"}
                                width={28}
                                height={28}
                              />
                            </a>
                          </Link>
                          <Link href={teamUrl}>
                            <a className={style.link} title={team.name}>
                              {team.name}
                            </a>
                          </Link>
                        </div>
                      </td>
                    </tr>
                  )
                })}
            </tbody>
          </table>
        </Col>
        <Col className={style.playerCareerContainer} md={6} lg={6} xl={6}>
          <h3>Nazionali</h3>
          <table>
            <thead>
              <tr>
                <th>Stagione</th>
                <th>Nazionale</th>
              </tr>
            </thead>
            <tbody>
              {aggregatedNationals.length > 0 &&
                aggregatedNationals.map((teamWithSeasonName, index) => {
                  const team = teamWithSeasonName
                  const teamUrl = getTeamPageUrl(team.calciocomSlug!)

                  return (
                    <tr key={index} data-gender="male">
                      <td>{teamWithSeasonName.seasonName}</td>
                      <td>
                        <div className={style.content}>
                          <Link href={teamUrl}>
                            <a title={team.name}>
                              <Image
                                src={team.image?.path || ImageConstants.TEAM_MISSING_IMAGE_PATH}
                                alt={team.name}
                                title={team.name}
                                layout={"intrinsic"}
                                width={28}
                                height={28}
                              />
                            </a>
                          </Link>
                          <Link href={teamUrl}>
                            <a className={style.link} title={team.name}>
                              {team.name}
                            </a>
                          </Link>
                        </div>
                      </td>
                    </tr>
                  )
                })}
            </tbody>
          </table>
        </Col>
      </Row>
    </div>
  )
}
